import { ContainerInner } from 'elements';
import styled from 'styled-components';
import { mediaQuery } from 'theme';

export const ProductDescriptions = styled(ContainerInner)`
  display: grid;
  grid-template: 1fr / repeat(3, 1fr);
  gap: 40px;
  padding: 30px 0 70px 0;

  h2 {
    font-size: 1.4rem;
    font-weight: 600;
  }

  p {
    font-size: 1.3rem;
    font-family: 'Source Sans Pro', sans-serif;
    margin: 5px 0 0 0;
    letter-spacing: 0.05em;
  }

  @media ${mediaQuery.tablet} {
    grid-template: repeat(3, auto) / 1fr;
    gap: 20px;
    background-color: ${({ theme }) => theme.colors.brandBlue};
    margin: 30px 0;
    padding: 30px 20px 70px 20px;

    h2 {
      color: ${({ theme }) => theme.colors.brandGold};
    }

    p {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;
